/* The BUILD section of the studio sidebar: the five build items as links,
 * each with a done/to-do badge. The progress hooks live here so they run
 * once on the persistent shell. */
import React from 'react';
import {
    Map,
    Plug,
    Users,
    Workflow
} from 'lucide-react';
import {
    useBuildProgress
} from './useBuildProgress';
import type {
    StageStatus
} from './useBuildProgress';

const BUILD_ITEMS = [
    {
        seg: 'sources',
        label: 'Sources',
        icon: Plug
    },
    {
        seg: 'workflows',
        label: 'Workflows',
        icon: Workflow
    },
    {
        seg: 'journeys',
        label: 'Journeys',
        icon: Map
    },
    {
        seg: 'identity',
        label: 'Identity',
        icon: Users
    }
] as const;


export default function BuildRail({
    tailSeg,
    go
}: {
    tailSeg: string | undefined;
    go: (to: string) => void;
}) {
    const progress = useBuildProgress();

    const status: Record<string, StageStatus> = {
        sources: progress.sources,
        workflows: progress.workflows,
        journeys: progress.journeys,
        identity: progress.access
    };

    return (
        <>
            <span className="aps-rail-section aps-meta">Build</span>
            {BUILD_ITEMS.map((item) => {
                const Icon = item.icon;
                const done = status[item.seg]?.done === true;
                return (
                    <button
                        key={item.seg}
                        className={'aps-rail-link' + (tailSeg === item.seg ? ' active' : '')}
                        onClick={() => go(item.seg)}
                    >
                        <Icon size={16} />
                        <span style={{
                            flex: 1
                        }}>{item.label}</span>
                        <span className={'aps-badge aps-badge-sm '
                            + (done ? 'aps-badge-success' : 'aps-badge-warning')}>
                            {done ? 'done' : 'to do'}
                        </span>
                    </button>
                );
            })}
        </>
    );
}
